import { defineStore } from "pinia";
import { ref } from "vue";

export const useAlertStore = defineStore("alert", () => {
  const isOpen = ref(false);
  const message = ref("");
  const onConfirmCallback = ref<(() => void) | null>(null);

  const showAlert = (msg: string, callback?: () => void) => {
    message.value = msg;
    onConfirmCallback.value = callback || null;
    isOpen.value = true;
  };

  const confirm = () => {
    isOpen.value = false;
    if (onConfirmCallback.value) {
      onConfirmCallback.value();
      onConfirmCallback.value = null;
    }
  };

  const close = () => {
    isOpen.value = false;
    onConfirmCallback.value = null;
  };

  return {
    isOpen,
    message,
    showAlert,
    confirm,
    close
  };
});
